<section class="content">
  <div class="container-fluid">
    <div class="block-header">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <ul>
            <!-- <li class="breadcrumb-item"> -->
            <h4 class="page-title">Employee</h4>
            <!-- </li> -->
            <!-- <li class="breadcrumb-item bcrumb-1">
              <a routerLink="/dashboard/main">
                <i class="fas fa-home"></i> Home</a>
            </li>
            <li class="breadcrumb-item bcrumb-2">
              <a href="#" onClick="return false;">Forms</a>
            </li>
            <li class="breadcrumb-item active">Basic</li> -->
          </ul>
        </div>
      </div>
    </div>
    <!-- <app-maser-page-header></app-maser-page-header> -->
    <div class="row" style="margin-top: 20px;">
      <div class="col" *ngIf="!this.employeeService.is_display_employee_register_component">
        <button mat-fab color="primary" (click)="registerEmployee()">
          <mat-icon aria-hidden="false" aria-label="Example home icon">add</mat-icon>
        </button>
        <!-- ['id', 'name', 'mobile', 'gender_name','taluk_name','district_name' ,'office', 'role', 'joining_date', 'union_name']; -->
        <table class="table table-bordered table-hovered" style="margin-top: 12px;">
          <tr style="background: #97cdef;">
            <th style="width: 12%;">Name
              <input matInput type="text" #name_filter
                style="border: 2px solid lightgray;border-radius: 12px;margin-top: 10px;text-indent:10px">
            </th>
            <th style="width: 12%;">Mobile
              <input matInput type="text" #mobile_filter
                style="border: 2px solid lightgray;border-radius: 12px;margin-top: 10px;text-indent:10px">
            </th>
            <th style="width: 10%;">Gender name
            </th>
            <th>Taluk Name</th>
            <th>District Name</th>
            <th>Office</th>
            <th>Role</th>
            <th>Joining Date</th>
            <th>Union Name</th>
            <th>Edit</th>
          </tr>
          <tr *ngFor="let data of dataSource
          | globalSearch:'mobile': mobile_filter.value
          | globalSearch:'first_name': name_filter.value">
            <td>{{data['first_name']}}</td>
            <td>{{data['mobile']}}</td>
            <td>{{data['gender_name']}}</td>
            <td>{{data['taluk_name']}}</td>
            <td>{{data['district_name']}}</td>
            <td>{{data['office_name']}}</td>
            <td>{{data['role_name']}}</td>
            <td>{{data['joining_date'] | date:'medium'}}</td>
            <td>{{data['office_name']}}</td>
            <td style="cursor: pointer;">
              <mat-icon (click)="editEmployee(data)">edit</mat-icon>
            </td>
          </tr>
        </table>
      </div>
      <div class="col-5" *ngIf="this.employeeService.is_display_employee_register_component">
        <div class="row">
          <div class="col"></div>
          <div class="col-1">
            <button mat-fab color="primary" (click)="hideEmployeeRegister()">
              <i class="material-icons">
                clear
              </i>
            </button>
          </div>
        </div>
        <app-employee-register></app-employee-register>
      </div>
    </div>
  </div>
</section>